import classNames from 'classnames';
import * as React from 'react';

export const LessonLoader = ({ className }: { className?: string }) => {
  return (
    <svg
      role="img"
      width="304"
      height="308"
      aria-labelledby="loading-aria"
      viewBox="0 0 304 308"
      preserveAspectRatio="none"
      className={classNames({ 'bg-gray-200 rounded-md': true, [className || '']: !!className })}
    >
      <title id="loading-aria">Loading...</title>
      <rect
        x="0"
        y="0"
        width="100%"
        height="100%"
        clipPath="url(#clip-path)"
        style={{ fill: 'url("#fill")' }}
      />
      <defs>
        <clipPath id="clip-path">
          <path d="M 0 143 h 304 v 1 H 0 z" />
          <rect x="16" y="16" rx="8" ry="8" width="59" height="16" />
          <rect x="16" y="160" rx="7" ry="7" width="252" height="14" />
          <rect x="16" y="260" rx="4" ry="4" width="272" height="35" />
          <rect x="16" y="180" rx="7" ry="7" width="210" height="14" />
          <rect x="16" y="216" rx="4" ry="4" width="244" height="8" />
          <rect x="16" y="230" rx="4" ry="4" width="204" height="8" />
        </clipPath>
        <linearGradient id="fill">
          <stop offset="0.599964" stopColor="#f3f3f3" stopOpacity="1">
            <animate
              attributeName="offset"
              values="-2; -2; 1"
              keyTimes="0; 0.25; 1"
              dur="2s"
              repeatCount="indefinite"
            />
          </stop>
          <stop offset="1.59996" stopColor="#ecebeb" stopOpacity="1">
            <animate
              attributeName="offset"
              values="-1; -1; 2"
              keyTimes="0; 0.25; 1"
              dur="2s"
              repeatCount="indefinite"
            />
          </stop>
          <stop offset="2.59996" stopColor="#f3f3f3" stopOpacity="1">
            <animate
              attributeName="offset"
              values="0; 0; 3"
              keyTimes="0; 0.25; 1"
              dur="2s"
              repeatCount="indefinite"
            />
          </stop>
        </linearGradient>
      </defs>
    </svg>
  );
};
